import apiClient from './apiClient'

/**
 * Fetch countries
 * @param {string} languageCode
 * @returns Collection with countries
 */
export const getCountries = async (languageCode) => await apiClient.get('/api/Countries', { languageCode })